import { Component, OnInit } from '@angular/core';

@Component({
    template: require('./visitantes.component.html')
})
export class VisitantesComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/visitante/visitantes.component.ts
 **/